<div id="page-container" class="container">
  <div id="content-wrap">
    <mat-toolbar color="primary">
      <button mat-icon-button [routerLink]="['/']" style="opacity:0.6">
        <mat-icon>home</mat-icon>
      </button>
      <button mat-button *ngIf="loggedIn" color="accent" [routerLink]="['projects']">
        <h3>PROJEKTE</h3>
      </button>
    
      <div class="toolbar-spacer"></div>
      <div id="identity">
        <button id="login-button" mat-button *ngIf="!loggedIn" (click)="login()">
          <div id="login-button-text">anmelden</div>
          <mat-icon>person</mat-icon>
        </button>
        <button matTooltip="abmelden" mat-icon-button color="accent" *ngIf="loggedIn" (click)="logout()">
          <mat-icon>person</mat-icon>
        </button>
      </div>
    </mat-toolbar>
  
    <router-outlet></router-outlet>

  </div>

  <div id="footer-container">
    <div id="footer-wrap">
      <mat-divider style="margin-top: 12px; margin-bottom: 8px;"></mat-divider>
      <a [routerLink]="['impressum']">Impressum</a>
    </div>
  </div>

</div>

